"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.3979 2.414 19.1846 19.1906-1.3978 1.3965L17 19.8155V22H7v-9c0-1.1516.118-2.0786.2852-2.9023L1 3.8105 2.3979 2.414zM9 13c0-.412.0168-.7885.047-1.1399L15 17.8148V20H9v-7z"
  }), _react.default.createElement("path", {
    d: "m8.3413 5.5304 1.722 1.7226c.1984-.8981.3609-1.933.4163-3.253h3.0408c.0697 1.661.3878 3.2597.825 4.858.2919 1.0656.5511 2.012.63 3.3086L17 14.1918V13c0-2.0252-.365-3.3559-.7205-4.6517-.3919-1.4313-.6886-2.8606-.7572-4.3483H16.5V2h-9v2h.9777c-.026.5645-.0737 1.0689-.1364 1.5304z"
  })];
};

exports.default = _default;